// src/components/admin/page-management/section-forms/TeamMemberForm.js
import React, { useEffect, useState } from 'react';
import axios from "../../../../utils/axiosHandler";

const TeamMemberForm = ({ content, updateContent }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch unique departments for the dropdown
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get('/api/team-members');
        // Extract unique departments
        const uniqueDepartments = [...new Set(response.data
          .filter(member => member.department) // Remove empty departments
          .map(member => member.department))];

        setDepartments(uniqueDepartments.sort());
        setLoading(false);
      } catch (err) {
        console.error('Error fetching departments:', err);
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Team Members Section</h3>

      <div className="grid gap-6 mb-6">
        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Section Title
          </label>
          <input
            type="text"
            className="w-full p-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder="Our Team"
            value={content?.sectionTitle || ''}
            onChange={e => updateContent('sectionTitle', e.target.value)}
          />
        </div>

        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="flex items-center text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              checked={content?.showDivider || false}
              onChange={e => updateContent('showDivider', e.target.checked)}
              className="mr-3 h-5 w-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
            />
            Show Title Divider
          </label>
        </div>
      </div>


      <div className="grid md:grid-cols-2 gap-6 mb-6">
        {/* Layout Type */}
        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="block text-sm font-semibold text-gray-700 mb-2">Layout</label>
          <select
            className="w-full p-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            value={content?.layout || 'grid'}
            onChange={e => updateContent('layout', e.target.value)}
          >
            <option value="grid">Grid</option>
            <option value="list">List</option>
          </select>
          <p className="text-xs text-gray-500 mt-2">
            Grid shows members side by side, List stacks them vertically.
          </p>
        </div>

        {/* Department Dropdown */}
        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="block text-sm font-semibold text-gray-700 mb-2">Department Filter</label>
          <select
            className="w-full p-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            value={content?.department || ''}
            onChange={e => updateContent('department', e.target.value)}
          >
            <option value="">All Departments</option>
            {departments.map(dept => (
              <option key={dept} value={dept}>{dept}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-6">
        {/* Show Leadership Only */}
        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.showLeadershipOnly || false}
              onChange={e => updateContent('showLeadershipOnly', e.target.checked)}
              className="form-checkbox h-5 w-5 text-indigo-600 mr-3"
            />
            <span className="text-sm font-medium text-gray-700">Show Leadership Team Only</span>
          </label>
        </div>

        {/* Show Active Only */}
        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.activeOnly !== false}
              onChange={e => updateContent('activeOnly', e.target.checked)}
              className="form-checkbox h-5 w-5 text-indigo-600 mr-3"
            />
            <span className="text-sm font-medium text-gray-700">Show Active Members Only</span>
          </label>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-6">
        {/* Show Bio */}
        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.showBio || false}
              onChange={e => updateContent('showBio', e.target.checked)}
              className="form-checkbox h-5 w-5 text-indigo-600 mr-3"
            />
            <span className="text-sm font-medium text-gray-700">Show Bio</span>
          </label>
        </div>

        {/* Show Social Links */}
        <div className="bg-white border rounded-xl shadow-sm p-5">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.showSocialLinks || false}
              onChange={e => updateContent('showSocialLinks', e.target.checked)}
              className="form-checkbox h-5 w-5 text-indigo-600 mr-3"
            />
            <span className="text-sm font-medium text-gray-700">Show Social Links</span>
          </label>
        </div>
      </div>

    </div>
  );
};

export default TeamMemberForm;